import React from 'react';
import { formatDate } from '~/util';
import { BannerModal } from '~/components/Admin';
import { BannerType } from '~/services';

interface BannerRowProps {
    banner: BannerType;
}

export function BannerRow({ banner }: BannerRowProps) {
    const [show, setShow] = React.useState(false);

    return (
        <tr className="banner-list-row">
            <td>{formatDate(banner.start_date)}</td>
            <td>{formatDate(banner.end_date)}</td>
            <td className="text-truncate">{banner.content}</td>
            <td className="p-0 align-middle text-center">
                <button
                    className="btn btn-default btn-sm"
                    type="button"
                    onClick={() => setShow(true)}
                    aria-label="Edit Banner"
                >
                    <i className="fa-solid fa-edit" />
                </button>
                <BannerModal show={show} setShow={setShow} banner={banner} />
            </td>
        </tr>
    );
}
